var map = {
	"./assets/fonts/Inter-VariableFont_opsz,wght.ttf": 3694,
	"./assets/icons/3-layers-normal.svg": 59,
	"./assets/icons/3-layers.svg": 297,
	"./assets/icons/Avatar group.svg": 8513,
	"./assets/icons/Avatar.svg": 4320,
	"./assets/icons/Illustration.svg": 4501,
	"./assets/icons/_Step icon base.svg": 34,
	"./assets/icons/_Step icon base_done.svg": 7493,
	"./assets/icons/_Step icon base_stationary.svg": 6103,
	"./assets/icons/arrow-right.svg": 6415,
	"./assets/icons/bar-chart-2-normal.svg": 7900,
	"./assets/icons/bar-chart-2.svg": 5036,
	"./assets/icons/chat-active.svg": 7520,
	"./assets/icons/chat.svg": 8701,
	"./assets/icons/check-circle.svg": 2670,
	"./assets/icons/close.svg": 5837,
	"./assets/icons/digital.svg": 9117,
	"./assets/icons/effective.svg": 7642,
	"./assets/icons/facebook.svg": 3479,
	"./assets/icons/gmail.svg": 4811,
	"./assets/icons/ineffective.svg": 4121,
	"./assets/icons/info.svg": 6947,
	"./assets/icons/information.svg": 3787,
	"./assets/icons/linkedln.svg": 7110,
	"./assets/icons/logo.svg": 6962,
	"./assets/icons/logout.svg": 4277,
	"./assets/icons/mail.svg": 9814,
	"./assets/icons/moderate.svg": 76,
	"./assets/icons/plus.svg": 4491,
	"./assets/icons/twitter.svg": 8592,
	"./assets/icons/youtube.svg": 2054,
	"./assets/icons/zap.svg": 656,
	"./assets/images/Mockup wrap.png": 2976,
	"./assets/images/herobg.mp4": 7129,
	"./assets/images/image.png": 4,
	"./assets/images/side2.png": 4690,
	"./assets/images/side3.png": 5819,
	"./assets/images/side4.png": 5908,
	"./assets/images/side5.png": 8941,
	"./assets/images/side6.png": 1382,
	"./assets/images/side7.png": 399,
	"./components/CustomNode": 3537,
	"./components/CustomNode.tsx": 3537,
	"./components/SystemArchitecture": 4083,
	"./components/SystemArchitecture.tsx": 4083,
	"./components/SystemTestArchitecture": 1655,
	"./components/SystemTestArchitecture.tsx": 1655,
	"./components/modals/detailsmodal": 9008,
	"./components/modals/detailsmodal.tsx": 9008,
	"./components/modals/invitemodal": 872,
	"./components/modals/invitemodal.tsx": 872,
	"./components/modals/selectfilter": 410,
	"./components/modals/selectfilter.tsx": 410,
	"./components/modals/successmodal": 7038,
	"./components/modals/successmodal.tsx": 7038,
	"./components/partials/btn": 555,
	"./components/partials/btn.tsx": 555,
	"./components/partials/inputs": 7194,
	"./components/partials/inputs.tsx": 7194,
	"./components/partials/maincontainer": 9218,
	"./components/partials/maincontainer.tsx": 9218,
	"./components/partials/modalbackground": 9501,
	"./components/partials/modalbackground.tsx": 9501,
	"./components/partials/searchinput": 3780,
	"./components/partials/searchinput.tsx": 3780,
	"./components/partials/select": 3756,
	"./components/partials/select.tsx": 3756,
	"./components/partials/sidemodalcontainer": 5881,
	"./components/partials/sidemodalcontainer.tsx": 5881,
	"./components/partials/steps": 1887,
	"./components/partials/steps.tsx": 1887,
	"./components/reactflowchart/CategoryNode": 7011,
	"./components/reactflowchart/CategoryNode.tsx": 7011,
	"./components/reactflowchart/FlowCanvas": 5939,
	"./components/reactflowchart/FlowCanvas.tsx": 5939,
	"./components/reactflowchart/sampledata": 727,
	"./components/reactflowchart/sampledata.ts": 727,
	"./components/sidebar": 8023,
	"./components/sidebar/": 8023,
	"./components/sidebar/index": 8023,
	"./components/sidebar/index.tsx": 8023,
	"./components/tables": 8551,
	"./components/tables/": 8551,
	"./components/tables/index": 8551,
	"./components/tables/index.tsx": 8551,
	"./data/Config": 8729,
	"./data/Config.ts": 8729,
	"./data/response": 3736,
	"./data/response.ts": 3736,
	"./data/stores/authStore": 7445,
	"./data/stores/authStore.ts": 7445,
	"./data/stores/errorStore": 4167,
	"./data/stores/errorStore.ts": 4167,
	"./data/stores/loggerStore": 1131,
	"./data/stores/loggerStore.ts": 1131,
	"./data/useFetcher": 6106,
	"./data/useFetcher.tsx": 6106,
	"./pages/": 2767,
	"./pages/add-data-system/[id]": 3657,
	"./pages/add-data-system/[id].tsx": 3657,
	"./pages/add-data-system/components/about-form": 6611,
	"./pages/add-data-system/components/about-form.tsx": 6611,
	"./pages/add-data-system/components/data-collection-form": 8613,
	"./pages/add-data-system/components/data-collection-form.tsx": 8613,
	"./pages/add-data-system/components/data-flow-form": 3473,
	"./pages/add-data-system/components/data-flow-form.tsx": 3473,
	"./pages/add-data-system/components/external-data-sharing-form": 4617,
	"./pages/add-data-system/components/external-data-sharing-form.tsx": 4617,
	"./pages/add-data-system/components/fit-for-purpose-form": 7168,
	"./pages/add-data-system/components/fit-for-purpose-form.tsx": 7168,
	"./pages/dashboard": 4795,
	"./pages/dashboard.tsx": 4795,
	"./pages/data-system/[id]": 3,
	"./pages/data-system/[id].tsx": 3,
	"./pages/data-system/components/about": 6036,
	"./pages/data-system/components/about-edit": 1591,
	"./pages/data-system/components/about-edit.tsx": 1591,
	"./pages/data-system/components/about.tsx": 6036,
	"./pages/data-system/components/data-collection": 2338,
	"./pages/data-system/components/data-collection-edit": 4457,
	"./pages/data-system/components/data-collection-edit.tsx": 4457,
	"./pages/data-system/components/data-collection.tsx": 2338,
	"./pages/data-system/components/data-flow": 246,
	"./pages/data-system/components/data-flow-edit": 5861,
	"./pages/data-system/components/data-flow-edit.tsx": 5861,
	"./pages/data-system/components/data-flow.tsx": 246,
	"./pages/data-system/components/external-data-sharing": 4370,
	"./pages/data-system/components/external-data-sharing-edit": 9033,
	"./pages/data-system/components/external-data-sharing-edit.tsx": 9033,
	"./pages/data-system/components/external-data-sharing.tsx": 4370,
	"./pages/data-system/components/fit-for-purpose": 2893,
	"./pages/data-system/components/fit-for-purpose-edit": 9604,
	"./pages/data-system/components/fit-for-purpose-edit.tsx": 9604,
	"./pages/data-system/components/fit-for-purpose.tsx": 2893,
	"./pages/flow": 8963,
	"./pages/flow.tsx": 8963,
	"./pages/focal-person": 4109,
	"./pages/focal-person/": 4109,
	"./pages/focal-person/index": 4109,
	"./pages/focal-person/index.tsx": 4109,
	"./pages/index": 2767,
	"./pages/index.tsx": 2767,
	"./pages/invitation": 370,
	"./pages/invitation.tsx": 370,
	"./pages/recommendation": 1950,
	"./pages/recommendation.tsx": 1950,
	"./pages/request": 5760,
	"./pages/request.tsx": 5760,
	"./screens/flow": 192,
	"./screens/flow.tsx": 192,
	"./screens/forgotpassword": 6784,
	"./screens/forgotpassword.tsx": 6784,
	"./screens/home": 3332,
	"./screens/home.tsx": 3332,
	"./screens/invitation": 600,
	"./screens/invitation.tsx": 600,
	"./screens/login": 2131,
	"./screens/login.tsx": 2131,
	"./screens/request": 9591,
	"./screens/request.tsx": 9591,
	"./utils/get-currencies": 802,
	"./utils/get-currencies.ts": 802,
	"./utils/helpers": 6925,
	"./utils/helpers.ts": 6925,
	"./utils/types": 7721,
	"./utils/types.ts": 7721
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6729;